module.exports = __webpack_public_path__ + "static/media/sarkarizone21.66424c1d.jpg";